import BaseCircularReactWrapperView, {
  BaseCircularReactWrapperViewOptions,
} from 'molbio/maps/circular/BaseCircularReactWrapperView';
import {RingLayout} from 'molbio/maps/circular/CircularLayout';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export interface CircularReactWrapperViewOptions<TLayout extends RingLayout>
  extends BaseCircularReactWrapperViewOptions<TLayout> {
  /**
   * A function to actually render the React view to DOM.
   * @param basePairToAngle A linear function mapping an index in base pairs to an angle in radians on the
   *                        unit circle
   * @param layout The Backbone Layout object describing the layout of the ring
   * @param outerRadius The outer radius of the React view
   */
  renderReact: (
    basePairToAngle: (basePair: number) => number,
    layout: TLayout,
    outerRadius: number
  ) => JSX.Element;
}

/**
 * A component that helps render a single-layered / non-segmented React component as part of a RingView.
 */
export default class CircularReactWrapperView<
  TLayout extends RingLayout,
> extends BaseCircularReactWrapperView<TLayout> {
  renderReact!: (
    basePairToAngle: (basePair: number) => number,
    layout: TLayout,
    outerRadius: number
  ) => JSX.Element;

  initialize(options: CircularReactWrapperViewOptions<TLayout>): void {
    super.initialize(options);
    this.renderReact = options.renderReact;
  }

  _renderComponentWrapper(): void {
    renderToDOM(
      this.renderReact(this.basePairToAngle.bind(this), this.layout, this.getOuterRadius()),
      this.el
    );
  }
}
